export const handleAddPlusToPhone = (phone: string): string => {
  if (phone.startsWith("+") || phone.startsWith("00")) {
    return phone;
  }

  return `+${phone}`;
};
